import { Button, Typography } from '@breetometer/components';
import { AppTooltip } from 'BreetAssets';
import { viewHelpArticle } from 'BreetHelpers';

import { pageDataMap, type TooltipPageType } from './DialogTooltip.helpers';

const DialogTooltipContent = ({ page }: { page: TooltipPageType }) => {
	const pageData = pageDataMap[page];

	return (
		<div className='dialog-tool-tip bg-primary-500'>
			<div className='img-section'>
				<AppTooltip
					variant={page}
					className='svg-dark svg-dark-outline'
				/>
			</div>

			<div className='txt-section'>
				<Typography
					as='h5'
					className='color-tertiary-400'
				>
					{pageData.label}
				</Typography>
				<Typography className='color-neutral-50'>{pageData.description}</Typography>
			</div>

			{!!pageData.link && <Button onClick={viewHelpArticle(pageData.link)}>Learn More</Button>}
		</div>
	);
};

export default DialogTooltipContent;
